var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"updates-form"},[_c('div',{staticClass:"updates-form__form"},[_c('activity-widget',{attrs:{"reset-widget-send":true,"reset-widget-discard":true,"lead-id":Number(_vm.$route.params.id)},on:{"save":_vm.send}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }